var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M6,8.56H4v1.88H6Zm4,0H8v1.88h2Zm4,0H12v1.88h2Zm2-6.62H15V.05H13V1.94H5V.05H3V1.94H2A1.93,1.93,0,0,0,0,3.81V17.06A2,2,0,0,0,2,19H16a2,2,0,0,0,2-1.89V3.83A2,2,0,0,0,16,1.94Zm0,15.12H2V6.67H16Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }